(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.setAttribute('aria-hidden', String(expanded));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        toggle.focus();
      }
    });
    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target) && !toggle.contains(e.target) && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Thumbnail switching */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('#product-main-image');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-thumb-index]'));

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) mainImg.src = thumb.dataset.imgSrc;
      });
    });
  });

  /* Quantity buttons */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.product-quantity__wrap').querySelector('[data-qty-input]');
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.product-quantity__wrap').querySelector('[data-qty-input]');
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* Variant switching */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var radios = [].slice.call(form.querySelectorAll('[data-option-index]'));
    var variantId = form.querySelector('[data-variant-id]');
    var atcBtn = form.querySelector('[data-add-to-cart]');
    var productJson = null;

    try {
      var scriptTag = document.querySelector('[data-product-json]');
      if (scriptTag) productJson = JSON.parse(scriptTag.textContent);
    } catch (e) {}

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!productJson) return;
        var selected = [];
        productJson.options.forEach(function (name) {
          var checked = form.querySelector('input[name="' + name + '"]:checked');
          if (checked) selected.push(checked.value);
        });

        var match = productJson.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });

        if (match) {
          variantId.value = match.id;
          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            var amount = priceEl.querySelector('.product-info__amount');
            if (amount) amount.textContent = (match.price / 100).toLocaleString('en-US', { style: 'currency', currency: productJson.currency || 'USD' });
          }
          if (atcBtn) {
            atcBtn.disabled = !match.available;
            atcBtn.textContent = match.available ? atcBtn.dataset.addText || 'Add to cart' : atcBtn.dataset.soldText || 'Sold out';
          }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var PERIOD = 420;
  var REPS = 40;
  var SPEED = 80;
  var TOTAL = REPS * PERIOD;

  function wavePath() {
    var d = '';
    for (var i = 0; i < REPS; i++) {
      var o = i * PERIOD;
      d += (i === 0 ? 'M' + o + ',25 ' : '');
      d += 'C'+(o+42)+',25 '+(o+66)+',20 '+(o+95)+',12 ';
      d += 'C'+(o+125)+',4 '+(o+152)+',7 '+(o+181)+',19 ';
      d += 'C'+(o+209)+',31 '+(o+236)+',32 '+(o+269)+',26 ';
      d += 'C'+(o+304)+',20 '+(o+327)+',11 '+(o+355)+',11 ';
      d += 'C'+(o+382)+',11 '+(o+401)+',19 '+(o+420)+',25 ';
    }
    return d;
  }

  function straightPath() {
    return 'M0,25 L' + TOTAL + ',25';
  }

  function initMarquee(el) {
    var svg = el.querySelector('.marquee-svg');
    var pathEl = el.querySelector('defs path');
    var tp = el.querySelector('.marquee-tp');
    if (!svg || !pathEl || !tp) return;

    var isWavy = el.dataset.wavy === 'true';
    var shouldAnimate = el.dataset.animate === 'true';

    pathEl.setAttribute('d', isWavy ? wavePath() : straightPath());

    function setView() {
      var w = el.offsetWidth;
      if (isWavy) {
        svg.setAttribute('viewBox', '0 -12 ' + w + ' 56');
      } else {
        svg.setAttribute('viewBox', '0 4 ' + w + ' 28');
      }
    }
    setView();

    if (!shouldAnimate) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var offset = 0;
    var half = 0;
    var last = 0;
    var running = false;
    var rafId = 0;

    function tick(ts) {
      if (!running) return;
      if (!last) last = ts;
      var dt = (ts - last) / 1000;
      last = ts;
      offset -= SPEED * dt;
      if (half && offset <= -half) offset += half;
      tp.setAttribute('startOffset', offset);
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (running) return;
      running = true;
      last = 0;
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      cancelAnimationFrame(rafId);
    }

    requestAnimationFrame(function measure() {
      var len = tp.getComputedTextLength();
      if (len === 0) { requestAnimationFrame(measure); return; }
      half = len / 2;
      start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0 }).observe(el);
    }

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(setView, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.marquee-wave').forEach(initMarquee);
    });
  } else {
    document.querySelectorAll('.marquee-wave').forEach(initMarquee);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-store"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.section-store').forEach(function (root) {
    var buttons = [].slice.call(root.querySelectorAll('[data-filter]'));
    var cards = [].slice.call(root.querySelectorAll('[data-tags]'));

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var f = btn.dataset.filter;
        cards.forEach(function (card) {
          card.hidden = f !== 'all' && card.dataset.tags !== f;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smwht-portfolio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-smwht-portfolio]');
  if (!root) return;
  const pills = root.querySelectorAll('.smwht-filter-pill');
  const cards = root.querySelectorAll('.smwht-project-card');

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      const filter = pill.dataset.filter;
      pills.forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      cards.forEach(card => {
        if (filter === 'all' || card.dataset.tags.includes(filter)) {
          card.classList.remove('is-hidden');
        } else {
          card.classList.add('is-hidden');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-testimonial-section][data-layout="slider"]').forEach(function (section) {
    var slides = [].slice.call(section.querySelectorAll('.quote-slide'));
    var dots = [].slice.call(section.querySelectorAll('.quote-dot'));
    var current = 0;
    var animating = false;
    var autoplayMs = parseInt(section.dataset.autoplay, 10) * 1000;
    var autoplayTimer = null;

    function goTo(index, direction) {
      if (animating || index === current || slides.length < 2) return;
      animating = true;

      var dir = direction || (index > current ? 'next' : 'prev');
      var exitClass = dir === 'next' ? 'is-exit-left' : 'is-exit-right';
      var enterClass = dir === 'next' ? 'is-enter-right' : 'is-enter-left';
      var prev = slides[current];
      var next = slides[index];

      next.classList.add(enterClass);
      next.classList.remove('is-active');
      next.setAttribute('aria-hidden', 'false');
      next.offsetHeight;

      prev.classList.remove('is-active');
      prev.classList.add(exitClass);
      prev.setAttribute('aria-hidden', 'true');

      next.classList.remove(enterClass);
      next.classList.add('is-active');

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });

      current = index;

      setTimeout(function () {
        prev.classList.remove(exitClass);
        animating = false;
      }, 700);
    }

    section.querySelectorAll('.quote-nav__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        resetAutoplay();
        var dir = btn.dataset.dir;
        var next;
        if (dir === 'next') {
          next = (current + 1) % slides.length;
        } else {
          next = (current - 1 + slides.length) % slides.length;
        }
        goTo(next, dir);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        resetAutoplay();
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    function resetAutoplay() {
      if (!autoplayMs) return;
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(function () {
        goTo((current + 1) % slides.length, 'next');
      }, autoplayMs);
    }

    if (autoplayMs) {
      autoplayTimer = setInterval(function () {
        goTo((current + 1) % slides.length, 'next');
      }, autoplayMs);

      section.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
      section.addEventListener('mouseleave', function () { resetAutoplay(); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-bento"] && !Shopify.designMode) return;
  try {
    
(function () {
  const countdowns = document.querySelectorAll('.smwht-bento [data-countdown]');

  for (const el of countdowns) {
    const target = new Date(el.dataset.countdown).getTime();
    if (Number.isNaN(target)) continue;

    const tick = function () {
      const diff = Math.max(0, target - Date.now());
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor(diff / 3600000) % 24;
      const minutes = Math.floor(diff / 60000) % 60;
      const seconds = Math.floor(diff / 1000) % 60;
      const vals = { days: days, hours: hours, minutes: minutes, seconds: seconds };

      for (const [key, value] of Object.entries(vals)) {
        const node = el.querySelector(`[data-${key}]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      }
    };

    tick();
    setInterval(tick, 1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-celebration"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.smwht-celebration').forEach(function (root) {
      var timer = root.querySelector('[data-countdown]');

      if (timer) {
        var target = new Date(timer.dataset.countdown).getTime();

        if (!Number.isNaN(target)) {
          var tick = function () {
            var d = Math.max(0, target - Date.now());
            var values = {
              days: Math.floor(d / 86400000),
              hours: Math.floor(d / 3600000) % 24,
              minutes: Math.floor(d / 60000) % 60,
              seconds: Math.floor(d / 1000) % 60
            };

            Object.entries(values).forEach(function (entry) {
              var el = timer.querySelector('[data-' + entry[0] + ']');
              if (el) el.textContent = String(entry[1]).padStart(2, '0');
            });
          };

          tick();
          setInterval(tick, 1000);
        }
      }

      var code = root.querySelector('[data-code]');

      if (code) {
        code.addEventListener('click', function () {
          navigator.clipboard.writeText(code.dataset.code).then(function () {
            var small = code.querySelector('small');
            var original = small.textContent;
            small.textContent = small.dataset.copyHint;
            setTimeout(function () {
              small.textContent = original;
            }, 1500);
          }).catch(function () {});
        });
      }

      if (root.dataset.confetti === 'true') {
        var decor = root.querySelector('.smwht-celebration__decor');

        for (var i = 0; i < 28; i++) {
          var c = document.createElement('i');
          c.className = 'smwht-confetti';
          c.style.left = Math.random() * 100 + '%';
          c.style.animationDuration = 4 + Math.random() * 5 + 's';
          c.style.animationDelay = -Math.random() * 8 + 's';
          c.style.transform = 'rotate(' + Math.random() * 360 + 'deg)';
          decor.appendChild(c);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-gift-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.smwht-gift-guide').forEach(function (root) {
    var buttons = [].slice.call(root.querySelectorAll('[data-filter]'));
    var cards = [].slice.call(root.querySelectorAll('[data-tags]'));
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var f = btn.dataset.filter;
        cards.forEach(function (card) {
          card.hidden = f !== 'all' && !card.dataset.tags.split(' ').includes(f);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
